import Vue from 'vue'
const LACTOSE_UNIT = 'kgfm'

Vue.filter('lactose', function (value) {
  if (!value) return ''
  if (typeof value === 'string') return `${value} (${LACTOSE_UNIT})`
  if (typeof value === 'number') return `${value} ${LACTOSE_UNIT}`
})

Vue.filter('colorByPercentage', function (value) {
  if (value >= 90) return 'blue-grey'
  if (value >= 80) return 'light-green'
  if (value >= 50) return 'amber'
  return 'red'
})

Vue.filter('getColorToEmail', function (value) {
  return value ? 'warning' : 'primary'
})

Vue.filter('getIconToEmail', function (value) {
  return value ? 'star' : 'alternate_email'
})

Vue.filter('getColorToPhone', function (principal) {
  if (principal) {
    return 'warning'
  }
  return 'success'
})

Vue.filter('getIconToPhone', function (whatsapp) {
  if (whatsapp) {
    return 'message'
  }
  return 'phone_in_talk'
})
